import React from 'react';
import { Skeleton } from '@mantine/core';

import type { CarouselSpot } from '~/domains/cms/promo/carousel.contests/enums';
import useCmsPromoCarousel from '~/domains/cms/promo/carousel.contests/useCmsPromoCarousel';

import { Carousel } from './Carousel';

type ConnectedCarouselProps = {
  carouselSpot: CarouselSpot;
  order?: number;
};

export function ConnectedCarousel({ carouselSpot, order }: ConnectedCarouselProps) {
  const { data, isLoading, isError } = useCmsPromoCarousel(carouselSpot);

  if (isLoading || isError) {
    return <div style={{ order }}><Skeleton mih={170} visible /></div>;
  }

  return <Carousel slides={data} />;
}
